import { render } from "./dimensional-action.vue?vue&type=template&id=1bf243ee&scoped=true"
import script from "./dimensional-action.vue?vue&type=script&lang=js"
export * from "./dimensional-action.vue?vue&type=script&lang=js"

import "./dimensional-action.vue?vue&type=style&index=0&id=1bf243ee&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf243ee"]])

export default __exports__